import Api from "./Api";

const endpoint = "/templates";
export default {
    get(label) {
        return Api.fetchData(endpoint + "/" + label);
    },
    put(label, data) {
        return Api.putData(endpoint + "/" + label, data);
    }
};
